import { render } from "./App.vue?vue&type=template&id=37894077"
const script = {}

import exportComponent from "E:\\otherWork\\impulx.com\\vue\\admin\\node_modules\\_vue-loader@17.0.1@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__